import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './rootReducer';

const store = configureStore({ reducer: rootReducer });
//store.subscribe(() => console.log('Store', store.getState()));

export default store;
